import { useState, useCallback, useEffect } from "react";
import Header from "../../Pages/Header";
import Sidebar from "../../Pages/Sidebar";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import settingsApi from "Services/Settings";

// redux
import { profiledetails } from "../../Redux/ProfileSettings/actions";
import { closeSidebar } from "../../Redux/Sidebar/actions";

const useStyles = makeStyles((theme) => ({
  headstamps: {
    display: "flex",
    width: "100%",
    height: "111vh",
    // border: "5px solid red",
    overflow: "hidden",
    margin: 0,
    padding: 0,
    position: "relative",
    backgroundColor: "#EAEDEF",
  },
  sidebarWrapper: {
    width: (props) => (props.sidebarOpen ? 260 : 120),
    flexShrink: 0,
    // minHeight: "calc(100vh - 100px)",
    height: "109vh",
    overflowY: "auto",
    borderRadius: 8,
    backgroundColor: "#ffffff",
    boxShadow: "8px 0px 16px rgba(0, 0, 0, 0.04)",
    transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "160px !important",
      transform: (props) => (props.sidebarOpen ? "translateX(0)" : "translateX(-100%)"),
      transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      zIndex: 1300,
      boxShadow: "4px 0px 16px rgba(0, 0, 0, 0.12)",
    },
  },
  mainWrapper: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    // height: "100%",
    // // Allow content to fill remaining space without overflow
    // flexBasis: 0,
    overflow: "auto",
    backgroundColor: "#EAEDEF",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    backdropFilter: "blur(3px)",
    zIndex: 1200,
    opacity: (props) => (props.sidebarOpen ? 1 : 0),
    visibility: (props) => (props.sidebarOpen ? "visible" : "hidden"),
    transition: "opacity 0.3s ease, visibility 0.3s ease",
    // Hide backdrop on larger screens (desktop)
    [theme.breakpoints.up("md")]: {
      display: "none"
    },
  },
 layout: {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  overflowY: "auto",
  background: "#EAEDEF",
  padding: 16,

  scrollbarWidth: "none",

  "&::-webkit-scrollbar": {
    display: "none",
  },
},
  title: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    padding: "20px 0px 4px 0px",
  },
  // pages: {
  //   background: "#fff",
  //   borderRadius: 8,
  //   margin: 16,
  //   padding: 16,
  //   // minHeight: "calc(100vh - 70px)",
  //   overflowY: "auto",
  // },
  pages: {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  background: "#fff",
  borderRadius: 8,
  padding: 16,
  margin: 0,
  minHeight: "fit-content",
  overflowY:"auto",
},
}));

const HomeLayout = ({ children, icon, label, noPadding }) => {
  const dispatch = useDispatch();
  const [profileDetails, setProfileDetails] = useState([]);
  const sidebarOpen = useSelector((state) => state.sidebar.isOpen);
  const classes = useStyles({ sidebarOpen });

  // Get Admin profile details
  const getAdminProfileDetails = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setProfileDetails(res?.data?.data);
        dispatch(profiledetails(res?.data?.data));
      } else {
        setProfileDetails([]);
      }
    };
    const onFailure = (err) => {
      // console.log("get admin profile details api", err);
    };
    settingsApi.getProfileDetails({}).then(onSuccess, onFailure);
  }, [dispatch]);

  useEffect(() => {
    getAdminProfileDetails();
  }, [getAdminProfileDetails]);

  const handleBackdropClick = () => {
    dispatch(closeSidebar());
  };

  return (
    <div className={classes.headstamps}>
      {/* Backdrop scrim overlay for mobile viewports */}
      <div className={classes.backdrop} onClick={handleBackdropClick} />

      {/* Sidebar Container Wrapper */}
      <aside className={classes.sidebarWrapper}>
        <Sidebar profileDetails={profileDetails} />
      </aside>

      {/* Main Layout Area (Header + Body) */}
      <main className={classes.mainWrapper}>
        <Header profileDetails={profileDetails} />

        {/* Page Content Body */}
        <section className={classes.layout}>
          {icon && (
            <section className={classes.title}>
              {icon && <section>{icon}</section>}
              <section>
                <Typography sx={{ fontSize: 18 }} variant="body1">
                  {label}
                </Typography>
              </section>
            </section>
          )}

          <div
            className={classes.pages}
            style={
              noPadding
                ? { padding: 0 }
                : { padding: 16 }
            }
          >
            {children}
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomeLayout;